import { render, staticRenderFns } from "./configure-tab.vue?vue&type=template&id=7f830a90&scoped=true"
import script from "./configure-tab.vue?vue&type=script&lang=js"
export * from "./configure-tab.vue?vue&type=script&lang=js"
import style0 from "./configure-tab.vue?vue&type=style&index=0&id=7f830a90&prod&scoped=true&lang=css"
import style1 from "./configure-tab.vue?vue&type=style&index=1&id=7f830a90&prod&scoped=true&lang=css"
import style2 from "./configure-tab.vue?vue&type=style&index=2&id=7f830a90&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f830a90",
  null
  
)

export default component.exports